export const shipmentDuplicateConfig = {
  enabled: false,
  allowCompleted: false,
  duplicableFields: [
    'origin',
    'destination',
    'originLocationCode',
    'originLocationName',
    'destinationLocationCode',
    'destinationLocationName',
    'transportMode',
    'shipmentType',
    'serviceType',
    'incoterm',
    'incoterms',
    'incotermLocation',
    'internationalCarrier',
    'shippingLine',
    'rateCategory',
    'deliveryMode',
    'shipper',
    'consignee',
    'notify',
    'pl3'
  ],
  duplicableSubcollections: [] as string[]
};
